import * as models from './models';

export function GetReadableSize(lineItemTypeSize: models.LineItemTypeSize): string
export function GetReadableSize(width: number, height: number, type: string): string
export function GetReadableSize(widthOrLineItemTypeSize: number | models.LineItemTypeSize, height?: number, type?: string): string {
    if (typeof widthOrLineItemTypeSize !== 'number') {
        const lineItemTypeSize = widthOrLineItemTypeSize;
        return GetReadableSize(parseInt(lineItemTypeSize.width ?? '0', 10), parseInt(lineItemTypeSize.height ?? '0', 10), lineItemTypeSize.type ?? '');
    }

    const width = widthOrLineItemTypeSize;

    let s = '';

    if (width) {
        s += `${width}"`;

        if (height && width !== height) {
            s += ' × ';
        }
    }

    if (height && width !== height) {
        s += `${height}"`;
    }

    if (type) {
        s += ` ${type}`;
    }

    return s;
}

export function GetWidthHeightFromSize(size: string): { width: number; height: number } {
    const m = /(\d+(?:\.\d+)?)(?:.*?(\d+(?:\.\d+)?))?/.exec(size);
    if (m?.length !== 3) {
        return { width: 0, height: 0 };
    }

    let width = parseFloat(m[1]);
    let height = parseFloat(m[2]);

    if (!height) {
        height = width;
    } else if (!width) {
        width = height;
    }

    return { width, height };
}